<template>
    <div class="popup popup--mini" @mousedown.self="$emit('close')">
        <div class="popup__block">
            <div class="popup__top">
                <div class="popup__title">Группы:</div>
                <div class="popup__close" @click="$emit('close')"></div>
            </div>
            <div class="popup__content">
                <div class="pd-list" v-if="type === 'default'">
					<div class="pd-list__item" v-for="item in data" :key="item.id">
						<div class="default-checkbox">
							<input class="default-checkbox__input" checked disabled type="checkbox" id="Наименование товарной категории_1">
							<label class="default-checkbox__label" for="Наименование товарной категории_1">
								<span>
									{{ item.name }}
								</span>
							</label>
						</div>
					</div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "ProductCategoriesPopup",
    emits: ['close'],
    props: {
        type: {
            type: String,
            default: 'default'
        },
        data: {
            type: Array,
            required: true,
        }
    },
}
</script>


